module.exports = __webpack_public_path__ + "static/media/block_coffee_story_18.215fada9.png";